import http from "api/httpClient";

export type UnbilledYearItem = {
    year: string;
    months: Record<number, number[]>;
};

export type UnbilledYearsResponse = {
    years: UnbilledYearItem[];
};

export async function fetchUnbilledYears(): Promise<UnbilledYearsResponse> {
    return http.get("/api/v1/unbilled/years");
}

export type UnbilledRow = {
    Customer: string;
    TotalUnbilled: number;
    InTransit: number;
    InStock: number;
    DeliveredLessThanEqual10: number;
    DeliveredGreaterThan10: number;
    PodReceivedLessThanEqual10: number;
    PodReceivedGreaterThan10: number;
};

export type FetchUnbilledDataRequest = {
    year: string;
    month: number;
    day: number;
    filters: Record<string, string[]>;
    search?: string;
    from_date?: string;
    to_date?: string;
    page?: number;
    per_page?: number;
    sort_by?: string;
    sort_order?: string;
};

export type FetchUnbilledDataResponse = {
    rows: UnbilledRow[];
    page: number;
    page_size: number;
    total_items: number;
    total_pages: number;
    has_previous: boolean;
    has_next: boolean;
};

export async function fetchUnbilledData(
    payload: FetchUnbilledDataRequest
): Promise<FetchUnbilledDataResponse> {
    return http.post("/api/v1/unbilled/fetch-data", payload);
}



export type BranchwiseUnbilledRow = {
    ou_code: string | null;
    Branch: string;
    TotalUnbilled: number;
    InTransit: number;
    InStock: number;
    DeliveredLessThanEqual10: number;
    DeliveredGreaterThan10: number;
    PodReceivedLessThanEqual10: number;
    PodReceivedGreaterThan10: number;
};

export interface BranchwiseUnbilledResponse {
    rows: BranchwiseUnbilledRow[];
    page: number;
    page_size: number;
    total_items: number;
    total_pages: number;
    has_previous: boolean;
    has_next: boolean;
}

export async function fetchBranchWiseUnbilled(payload: {
    customer_name: string;
    year: string;
    month: number;
    day: number;
    filters?: Record<string, string[]>;
    search?: string;
    from_date?: string;
    to_date?: string;
    page?: number;
    per_page?: number;
    sort_by?: string;
    sort_order?: string;
}): Promise<BranchwiseUnbilledResponse> {
    return http.post("/api/v1/unbilled/branch-wise-unbilled", payload);
}




export type BranchCnDetailsRow = {
    cn_number: string;
    cn_date: string;
    consignor?: string;
    consignee?: string;
    origin?: string;
    destination?: string;
    status: string;
    value: number;
    transit_days?: number;
    delivery_to_pod?: number;
    pod_to_bill?: number;
};

export interface BranchCnDetailsResponse {
    rows: BranchCnDetailsRow[];
    page: number;
    page_size: number;
    total_items: number;
    total_pages: number;
    has_previous: boolean;
    has_next: boolean;
}

export async function fetchBranchCnDetails(payload: {
    customer_name: string;
    ou_code: string;
    year: string;
    month: number;
    day: number;
    filters?: Record<string, string[]>;
    search?: string;
    status?: string;
    from_date?: string;
    to_date?: string;
    page?: number;
    per_page?: number;
    sort_by?: string;
    sort_order?: string;
}): Promise<BranchCnDetailsResponse> {
    return http.post("/api/v1/unbilled/branch-cn-unbilled-details", payload);
}


export async function downloadAllUnbilledDetails(payload: {
    year: string;
    month: number;
    day: number;
    filters: Record<string, string[]>;
    search?: string;
    from_date?: string;
    to_date?: string;
    sort_by?: string;
    sort_order?: string;
}): Promise<Blob> {
    return http.post("/api/v1/unbilled/download-all-details", payload, { responseType: "blob" });
}

export async function downloadBranchCnDetails(payload: {
    customer_name: string;
    ou_code: string;
    year: string;
    month: number;
    day: number;
    filters: Record<string, string[]>;
    search?: string;
    status?: string;
    from_date?: string;
    to_date?: string;
    sort_by?: string;
    sort_order?: string;
}): Promise<Blob> {
    return http.post("/api/v1/unbilled/download-branch-cn-unbilled-details", payload, { responseType: "blob" });
}